import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.overview.widget.chart');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Chart } from 'chart.js/auto';
import ChartjsPluginScrollBar from 'chartjs-plugin-scroll-bar';

Chart.register(ChartjsPluginScrollBar);

interface YearlyStat {
    year: number;
    papers: number;
    reports: number;
    patents: number;
    total: number;
}

@Component({
    selector: 'wiz-portal-overview-widget-chart',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.overview.widget.chart/view.scss */
/* src/app/portal.overview.widget.chart/view.scss: no such file or directory */`],
})
export class PortalOverviewWidgetChartComponent implements OnInit {
    @Input() periodStart: number;
    @Input() periodEnd: number;
    @Input() stats: YearlyStat[] = [];

    private avgChart?: Chart;

    constructor(@Inject( Service    )         public service: Service    ) { }

    public async ngOnInit() {
        await this.service.init();
        this.renderChart();
        await this.service.render();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['stats'] && !changes['stats'].firstChange) {
            this.renderChart();
        }
    }

    private renderChart(): void {
        if (!this.stats || this.stats.length === 0) return;

        // 라벨 (연도)
        const labels = this.stats.map(s => String(s.year));
        const total = labels.length;

        const omit = total > 15;  // 15개 초과일 때만 축약
        const keep = 4;               // 앞뒤 4개
        const ellipsisIndex = Math.floor(total / 2); // "..."를 표시할 위치(대략 가운데)


        // 굵기
        const count = this.stats.length;

        // 대략적인 규칙 (취향에 맞게 조절 가능)
        let maxBarThickness = 20;
        let categoryPercentage = 0.7;
        let barPercentage = 0.7;

        if (count <= 5) {
            maxBarThickness = 36;
            categoryPercentage = 0.9;
            barPercentage = 0.9;
        } else if (count <= 10) {
            maxBarThickness = 28;
            categoryPercentage = 0.8;
            barPercentage = 0.8;
        } else if (count <= 20) {
            maxBarThickness = 18;
            categoryPercentage = 0.7;
            barPercentage = 0.7;
        } else {
            maxBarThickness = 12;
            categoryPercentage = 0.6;
            barPercentage = 0.6;
        }



        // 데이터셋
        const data = {
            labels,
            datasets: [
                {
                    label: '논문',
                    data: this.stats.map(s => s.papers),
                    backgroundColor: '#3361DE',
                    borderRadius: 4,
                    maxBarThickness,
                    categoryPercentage,
                    barPercentage
                },
                {
                    label: '특허',
                    data: this.stats.map(s => s.patents),
                    backgroundColor: '#FFBCF9',
                    borderRadius: 4,
                    maxBarThickness,
                    categoryPercentage,
                    barPercentage
                },
                {
                    label: '보고서',
                    data: this.stats.map(s => s.reports),
                    backgroundColor: '#C9E4FF',
                    borderRadius: 4,
                    maxBarThickness,
                    categoryPercentage,
                    barPercentage
                }
            ]

        };

        const config = {
            type: 'bar' as const,
            data,
            options: {
                responsive: true,
                maintainAspectRatio: false,
                layout: { padding: 0 },
                scales: {
                    x: {
                        // min: 0,
                        // max: 4, // 👉 연도가 많으면 스크롤로 보이게
                        grid: { display: false },
                        ticks: {
                            autoSkip: true,          // ✅ 다시 켜기
                            maxTicksLimit: 10,        // ✅ 한 번에 보일 라벨 개수 제한
                            font: { size: 14, weight: 'bold' }, // 글자 크기도 조금 줄이고
                            maxRotation: 0,
                            minRotation: 0,
                            callback: (value: any, index: number) => labels[index],
                        },
                        border: {
                            display: true,
                            width: 2,
                            color: '#DFE1E5'
                        },
                        stacked: false
                    },
                    y: {
                        display: false,
                        grid: { display: false },
                        beginAtZero: true,
                    }
                },
                animation: false,
                plugins: {
                    scrollBar: {
                        enable: false,
                        scrollType: 'Horizontal'
                    },
                    legend: {
                        position: 'bottom',
                        labels: {
                            usePointStyle: true,
                            pointStyle: 'circle',
                            boxWidth: 7,
                            boxHeight: 7,
                            color: '#707988',
                            font: { size: 14 },
                            padding: 14,
                        }
                    },
                    tooltip: {
                        mode: 'index',
                        intersect: false,
                    },
                }
            }
        };

        const elmt = document.getElementById('avgChart') as HTMLCanvasElement | null;
        if (elmt) {
            const ctx = elmt.getContext('2d');
            if (ctx) {
                this.avgChart?.destroy();
                this.avgChart = new Chart(ctx, config);
            }
        }
    }

}

export default PortalOverviewWidgetChartComponent;